<script setup lang="ts">
  import { useBranchList } from '@/models/branch'

  defineProps<{
    required?: boolean,
    placeholder?: string,
  }>()

  const modelValue = defineModel<number | null>({ required: true })

  const { branches, loading, getData } = useBranchList()
  getData({ search: undefined })
</script>

<template>
  <app-select
    v-model="modelValue"
    label="Pilih Cabang"
    :placeholder="placeholder ?? 'Pilih Cabang'"
    :loading="loading"
    :required="required">
    <option :value="undefined">
      - Pilih Cabang -
    </option>
    <option
      v-for="branch in branches"
      :key="branch.id"
      :value="branch.id">
      {{ branch.code }}
    </option>
  </app-select>
</template>
